export const InteractionSection = {
  INTERACTION_SECTION_HEAD: '인터랙티브 AI 기술로 몰입감 뿜뿜!\n요즘 콘텐츠 플레이',
  INTERACTION_SECTION_HEAD_MOBILE: '인터랙티브 AI 기술로\n몰입감 뿜뿜!\n요즘 콘텐츠 플레이',
  INTERACTION_SECTION_BODY:
    '인터랙티브 AI 기술로 나의 음성, 감정, 모션을 인식하니까!\n내 취향에 맞게 여러가지 스토리, 결말을 선택할 수 있어요.',
  INTERACTION_SECTION_INTERACTIONS_A: ['머리', '손', '시선', '얼굴'],
  INTERACTION_SECTION_INTERACTIONS_B: ['음성', '입', '터치', '표정'],
};
